import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";

import { Image, constructSizes } from "@lululemon/ui-library";

import styles from "./visual-story-grid-item.module.scss";

const VisualStoryGridItem = ({
  classes,
  heading,
  imageProps,
  subContent,
  ...otherProps
}) => {
  const hasImage = !!imageProps?.src || !!imageProps.mobileSrc;

  // Default responsive image sizing is based on 3-column wide card
  const DEFAULT_IMAGE_MAX_WIDTH = 624;
  const DEFAULT_IMAGE_SIZES = constructSizes([
    { breakpoint: "1372px", slotSize: "312px" },
    { breakpoint: "992px", slotSize: "22vw" },
    { breakpoint: "768px", slotSize: "31vw" },
    { slotSize: "97vw" }
  ]);

  return (
    <div
      className={cs(styles.card, "lll-text-body-2", classes.container)}
      {...otherProps}
    >
      {!!hasImage && (
        <div
          className={cs(styles.media, {
            [classes.mediaContainer]: classes.mediaContainer
          })}
        >
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <Image
            {...imageProps}
            className={cs(styles.mediaImage, {
              [imageProps.className]: imageProps.className
            })}
            containerClassName={cs({
              [imageProps.containerClassName]: imageProps.containerClassName
            })}
            maxWidth={imageProps.maxWidth || DEFAULT_IMAGE_MAX_WIDTH}
            sizes={imageProps.sizes || DEFAULT_IMAGE_SIZES}
          />
        </div>
      )}
      <div className={cs(styles.content, classes.contentContainer)}>
        {!!heading && (
          <h3 className={cs(styles.content_heading, classes.heading)}>
            {heading}
          </h3>
        )}
        {!!subContent && (
          <div
            className={cs(
              styles.content_subContent,
              "lll-text-body-1",
              classes.subContent
            )}
          >
            {subContent}
          </div>
        )}
      </div>
    </div>
  );
};

VisualStoryGridItem.propTypes = {
  /** Optional classes to be added to any of the elements within the card */
  classes: PropTypes.shape({
    container: PropTypes.string,
    mediaContainer: PropTypes.string,
    contentContainer: PropTypes.string,
    subContent: PropTypes.node,
    heading: PropTypes.string
  }),
  heading: PropTypes.string,
  /** Accepts same props list as <Image /> component */
  imageProps: PropTypes.shape({
    ...Image.propTypes,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    maxWidth: PropTypes.number,
    sizes: PropTypes.string,
    src: PropTypes.string,
    mobileSrc: PropTypes.string
  }),
  subContent: PropTypes.node
};

VisualStoryGridItem.defaultProps = {
  classes: {},
  heading: "",
  imageProps: null,
  subContent: null
};

export default VisualStoryGridItem;
